import React, { useState } from 'react';
import './styles.css';

const BasicSearchForm = props => {
  const onSubmit = e => {};

  const [searchQuery, setSearchQuery] = useState('');
  const action = `/pub/search/all/${searchQuery}`;

  return (
    <form
      className="basic-search-form"
      action={action}
      method="POST"
      onSubmit={onSubmit}
    >
      <button className="basic-search-form__submit" type="submit" />
      <div className="basic-search-form__wrap">
        <input
          type="text"
          value={searchQuery}
          className="basic-search-form__input"
          placeholder="Search"
          onChange={e => {
            setSearchQuery(e.target.value);
          }}
        />
        <label className="basic-search-form__label" />
      </div>
    </form>
  );
};

BasicSearchForm.propTypes = {};

export default BasicSearchForm;
